module.exports = __webpack_public_path__ + "static/media/total-goals.77e68596.svg";